export default "/get-lending-tokens.a5124bca47999fb94203020c00e7da15.png";